import React, { Fragment } from 'react';
import {Avatar, Card, CardContent, CardHeader, List, ListItem, ListItemText } from "@material-ui/core";
import GetAppIcon from '@material-ui/icons/GetApp';
import {CSVLink} from "react-csv";

const ExportCard = ({cardClasses, exportData}) => (
    <Card component={Card} className={cardClasses.card}>
        <div>
            <CardHeader
                avatar={
                    <Avatar aria-label="type" className={cardClasses.contact}>
                        <GetAppIcon/>
                    </Avatar>
                }
                title={"Export Data"}
                subheader={''}
            />
            <CardContent className={cardClasses.minHeight}>
                <List>
                    {exportData.sections.map((item, idx) => {
                        return (
                            <Fragment key={idx.toString()}>
                                {item.data ? (
                                    <ListItem>
                                        <ListItemText>
                                            <CSVLink
                                                data={item.data}
                                                style={{textDecoration: 'none'}}
                                            >
                                                {item.label}
                                            </CSVLink>
                                        </ListItemText>
                                    </ListItem>
                                ) : null}
                            </Fragment>
                        );
                    })}
                </List>
            </CardContent>
        </div>
    </Card>
);

export default ExportCard;
